<form [formGroup]="leningen">
    <div *ngIf="box3Leningen.length > 0">
        <div formArrayName="box3Leningen">
            <div *ngFor="let item of box3Leningen.controls; let i = index; "
                 [formGroupName]="i" class="row">
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Omschrijving' : ''"
                                                class="col-auto custom-input-250"
                                                formControlName="omschrijving"
                                                id="omschrijving"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Leningnummer' : ''"
                                                class="col-auto custom-input-175"
                                                formControlName="rekeningNummer"
                                                id="rekeningNummer"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Schuld 1-1-' + this.jaar : ''"
                                                  [minValue]="0"
                                                  align="right"
                                                  class="col-auto custom-input-150"
                                                  formControlName="bedrag"
                                                  id="bedrag"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [label]="i === 0 ? 'Aanwending lening' : ''"
                                                  [options]="soortAanwending"
                                                  class="col-auto custom-input-200"
                                                  formControlName="aanwending"
                >
                </snelstart-ui-select-form-control>

                <snelstart-ui-select-form-control
                        (change)="saveForm()"
                        [disabledControl]="item.value.aanwending === LeningAanwending.OVERIG || item.value.aanwending === null"
                        [label]="i === 0 ? 'Kies woning' : ''"
                        [options]="onroerendeZaken"
                        class="col-auto custom-input-125"
                        formControlName="wozNummerWaarLeningBijHoort"
                        placeholder="n.v.t"
                >
                </snelstart-ui-select-form-control>
                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [disabledControl]="item.value.aanwending === LeningAanwending.OVERIG || item.value.aanwending === null"
                                                  [label]="i === 0 ? 'Land van lening' : ''"
                                                  [options]="optionsLandcodes"
                                                  class="col-auto custom-input-150"
                                                  formControlName="landCode"
                                                  label="Land"
                                                  placeholder="n.v.t"
                >
                </snelstart-ui-select-form-control>
                @if (this.aangifte.box3?.berekenWerkelijkRendement) {
                    <snelstart-ui-button
                            (click)="this.showDialog(i)"
                            [class]="i === 0 ? 'me-1 pt-3 custom-input-100' : 'me-1 custom-input-100'"
                            [icon]="heeftOWR[i] ? 'check' : 'plus'"
                            type="secondary">
                        OWR
                    </snelstart-ui-button>
                }
                <snelstart-ui-button (click)="verwijderRijLeningen(i)"
                                     [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto '"
                                     icon="trash"
                                     iconType="light"
                                     id="buttonDeleteKosten"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
            </div>
        </div>
    </div>
</form>

<div *ngIf="box3Leningen.length === 0">
    <snelstart-ui-button (click)="addRijLeningen()" class="snelstart-ui-button" icon="plus"
                         type="link">Schuld invullen
    </snelstart-ui-button>
</div>
<div *ngIf="box3Leningen.length > 0">
    <snelstart-ui-button (click)="addRijLeningen()" class="snelstart-ui-button" icon="plus"
                         type="link">Schuld toevoegen
    </snelstart-ui-button>
</div>

<div class="pt-2">
    <snelstart-ui-alert *ngIf="this.showAlertGeenBox3Woning" class="pt-6" type="warning">
        Let op! Je geeft aan dat de lening voor een box 3-woning is, maar er zijn geen onroerende zaken in box 3
        ingevuld.
    </snelstart-ui-alert>
</div>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible"
                                [title]="getOWRDialogTitel(index)"
                                id="owrBank"
                                size="lg">
    <snelstart-ui-dialog-body>
        <form [formGroup]="leningen">
            <div *ngIf="box3Leningen.length > 0" class="row">
                <div formArrayName="box3Leningen">
                    <div *ngFor="let item of box3Leningen.controls; let i = index; "
                         [formGroupName]="i">
                        <div *ngIf="i === this.index">
                            <snelstart-ui-number-form-control (change)="saveForm()"
                                                              [decimals]="0"
                                                              [label]="'Schuld 31-12-' + this.jaar"
                                                              [minValue]="0"
                                                              [required]=true
                                                              align="right"
                                                              class="custom-input-275 col-auto"
                                                              formControlName="hoofdsom3112"
                                                              id="bedrag"
                                                              prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                            <snelstart-ui-number-form-control (change)="saveForm()"
                                                              [decimals]="0"
                                                              [label]="'Betaalde rente in ' + this.jaar"
                                                              [minValue]="0"
                                                              [required]=true
                                                              align="right"
                                                              class="custom-input-275 col-auto"
                                                              formControlName="rente"
                                                              id="bedrag"
                                                              prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                            <snelstart-ui-number-form-control (change)="saveForm()"
                                                              [decimals]="0"
                                                              [label]="'Kwijtscheldingswinst/waardeverandering'"
                                                              [required]=true
                                                              align="right"
                                                              class="custom-input-275 col-auto"
                                                              formControlName="bijzondereWaardevermindering"
                                                              id="bedrag"
                                                              prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                            <div class="pt-2 pb-2">
                                <div class="d-flex align-items-center">
                                    <div class="result-inline">
                                        @let rendementSchulden = getBerekendeWerkelijkRendement(i);
                                        Werkelijk rendement in {{ jaar }} =
                                        € {{ rendementSchulden != null ? (rendementSchulden * -1 | number:'1.0-2') : '0' }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren
        </snelstart-ui-button>
        <snelstart-ui-button btn-x icon="check" id="save" type="primary">Opslaan
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>


